import React from 'react';

const LandingContext = React.createContext();

export default LandingContext;
